import type { RootState } from "@/app/store";

export const selectCarCrusher = (state: RootState) => state.carCrusher;
export const selectNextCrushTime = (state: RootState) =>
  state.carCrusher.nextCrushTime;
